/**
 * SeminarHistory
 */
export default class SeminarHistory {

    // constructor
    constructor(selector) {
        let _this = this;
        this.$plugin = $(selector);
        if (this.$plugin.length === 0) {
            return false;
        }
        this.$result = this.$plugin.find('[data-tncp-plugin-seminarhistory="result"]');
        this.init();

    }

    // on init
    init() {
        const vm = this;
        vm.getResults();
        vm.certificateAttendanceForm();
        vm.synchronizeValues('[data-tncp-seminarhistory-synchronizevalues]');

        // on form submit
        vm.$plugin.on('submit', '[data-tncp-plugin-seminarhistory="filterForm"]', () => {
            vm.getResults();
            return false;
        });


    }

    getResults() {
        let vm = this;
        vm.$plugin.attr('data-form--isloading', 'true');

        return new Promise((resolve, reject) => {
            let $form = vm.$plugin.find('[data-tncp-plugin-seminarhistory="filterForm"]');
            let serializedFilters = $form.serialize();
            vm.request = window.xhrRequest({
                url: $form.attr('action'),
                method: 'POST',
                data: serializedFilters
            });
            vm.request.then((response) => {
                resolve(response);
                vm.$result.html(response.data.content);
                vm.$plugin.attr('data-form--isloading', 'false');

                var $stickyTimeline = $('.js-timeline__sticky');
                $stickyTimeline.css('width', $stickyTimeline.parent().width()).fixedsticky();
                $(window).resize(() => {
                    $stickyTimeline.css('width', $stickyTimeline.parent().width());
                });
                $('.fixedsticky-dummy').css('display', 'none');

                $('.js-popup-link--inline').magnificPopup({
                    type:'inline',
                    midClick: true
                });

                $('html').on('click', '[data-certificateattendance-title]', function() {

                    // set values for modal
                    $('[data-certificateattendance-title-val]').text($(this).data('certificateattendanceTitle'));
                    $('[data-certificateattendance-provider-id-val]').val($(this).data('certificateattendanceProviderId'));
                    $('[data-certificateattendance-seminar-id-val]').val($(this).data('certificateattendanceSeminarId'));

                    // initial behaviour on link clicking for modal
                    $(document).find('[data-certificateattendance-section="form"]').show();
                    $(document).find('[data-certificateattendance-section="success"]').hide();
                    $(document).find('[data-certificateattendance-section="error"]').hide();
                    $(document).find('[name="tx_tuevnordcustomerportal_api[message]"]').val('');
                });

            }).catch((e) => {
                reject(e);
            });
        });
    }

    // on certificate attendance submit (Teilnahmebescheinigungs-Formular)
    certificateAttendanceForm() {
        let vm = this;
        $(vm.$plugin).find('#modal_certificateattendance form').submit(function(event) {
            const $formEl = $(this);
            let serializedData = $formEl.serialize();
            $formEl.find('[data-certificateattendance-section="error"]').hide();
            vm.disableForm($formEl);
            vm.request = window.xhrRequest({
                url: $formEl.attr('action'),
                method: 'POST',
                data: serializedData
            });
            vm.request.then(() => {
                $formEl.find('[data-certificateattendance-section="success"]').show();
                $formEl.find('[data-certificateattendance-section="form"]').hide();
            }).catch((e) =>{
                $formEl.find('[data-certificateattendance-section="error"]').show();

            }).then(() => {
                vm.disableForm($formEl, false);
            });
            event.preventDefault();
        });
    }

    // disable all form fields
    disableForm($form, disable = true) {
        let $selectors = $form.find('button, input, select, textarea');
        if (disable === true) {
            $selectors.attr('disabled', true);
        } else {
            $selectors.removeAttr('disabled');
        }
    }

    // synchronize values and submit ob change
    synchronizeValues(selector) {
        let vm = this;
        $(selector).change(function() { // listen on change of selector
            let $vm = $(this); // this jquery obj
            $(selector).val($vm.val()); // seems weird, but changes the values of all form elements with the same selector
            vm.getResults();
        });
    }

}

